import React, {Component} from "react";
import {Col} from "reactstrap";

export class VersionBlock extends Component {
    render() {
        const versionName = process.env.REACT_APP_VERSION_NAME;
        const versionCode = process.env.REACT_APP_VERSION_CODE;
        const shouldShow = versionName && versionCode;
        const versionString = versionName + " (" + versionCode + ")";
        return <Col>{shouldShow && versionString}</Col>
    }
}